import { memo, useMemo, useState, type MouseEvent } from 'react'
import i18next, { t } from 'i18next'
import { IconButton, Menu, MenuItem } from '@mui/material'
import * as Styled from './sidebar.styled'
import type { SidebarLanguageMap } from './sidebar.types'

import flagPL from 'assets/images/flags/pl.png'
import flagEN from 'assets/images/flags/en.png'

const SidebarLanguage = memo((): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const openMenu = (event: MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const closeMenu = (): void => {
    setAnchorEl(null)
  }

  const isMenuOpen = Boolean(anchorEl)

  const languagesMap: SidebarLanguageMap = useMemo(
    () => ({
      pl: {
        srcFlag: flagPL,
        textNative: 'Polski',
      },
      en: {
        srcFlag: flagEN,
        textNative: 'English',
      },
    }),
    []
  )

  return (
    <>
      <IconButton
        onClick={openMenu}
        aria-haspopup="true"
        aria-label={t('sidebar.language.buttonText') ?? ''}
        {...(isMenuOpen && { 'aria-expanded': true, 'aria-controls': 'sidebar-language-menu' })}
      >
        <Styled.LogoLanguage src={languagesMap[i18next.language].srcFlag} alt={t('sidebar.language.flag') ?? ''} />
      </IconButton>

      <Menu id="sidebar-language-menu" anchorEl={anchorEl} open={isMenuOpen} onClose={closeMenu} onClick={closeMenu}>
        {i18next.languages.map(language => (
          <MenuItem key={language} onClick={async () => await i18next.changeLanguage(language)}>
            {languagesMap[language].textNative}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
})

SidebarLanguage.displayName = 'SidebarLanguage'

export { SidebarLanguage }
